import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getAcademicSessions } from "../ApiService/ApiService";

export const fetchAcademicSessions = createAsyncThunk(
  "sessions/fetchSessions",
  async () => {
    const response = await getAcademicSessions();
    return response.data;
  }
);

const initialState = {
  sessions: [],
  loading: false,
  error: null,
};

export const sessionsSlice = createSlice({
  name: "sessions",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAcademicSessions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAcademicSessions.fulfilled, (state, action) => {
        state.loading = false;
        state.sessions = action.payload;
      })
      .addCase(fetchAcademicSessions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const selectAllSessions = (state) => state.sessions.sessions;
export const selectSessionsLoading = (state) => state.sessions.loading;
export const selectSessionsError = (state) => state.sessions.error;

export default sessionsSlice.reducer;
